import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Button,
    Checkbox,
    Grid,
    MenuItem,
    Paper,
    Stack,
    TextField,
    Tooltip, useTheme
} from "@mui/material";
import {useTranslation} from "react-i18next";
import SectionHeader from "../../../../util/component/SectionHeader";
import '../../style/SalesMarketing.css';
import * as Yup from 'yup';
import {useNavigate, useParams} from "react-router-dom";
import * as React from "react";
import {useContext, useEffect, useState} from "react";
import {
    VOUCHER_PROVIDER_AMAZON,
    VOUCHER_STATUS_AVAILABLE,
    VOUCHER_STATUS_EXPIRED,
    VOUCHER_STATUS_REFUNDED,
    VOUCHER_STATUS_USED
} from "../../component/Constants";
import {yupResolver} from "@hookform/resolvers/yup";
import {
    CheckCircleRounded,
    DoDisturbAltRounded,
    ExpandMore,
    InfoRounded
} from "@mui/icons-material";
import CustomModal from "../../component/CustomModal";
import {GlobalContext} from "../../../../util/state/GlobalContextProvider";
import {useVoucherActions} from "../../service/useVoucherActions";
import {Controller, useFieldArray, useForm} from "react-hook-form";
import FormControlLabel from "@mui/material/FormControlLabel";
import {useVoucherStatuses} from "./hooks/useVoucherStatuses";
import {
    UserLegalEntitiesOrDealersInputGroup
} from "../../component/UserLegalEntitiesOrDealersInputGroup/UserLegalEntitiesOrDealersInputGroup";
import {DatePicker, DateTimePicker} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import EmptyState from "../../../../util/component/EmptyState";
import {RootVoucherGetSingleResponse} from "./VoucherInterfaces";
import {Renewaltems} from "./components/RenewalItems";
import {setSnackbar} from "../../../../util/state/globalAction";
import {snackbarTypes} from "../../../../util/state/globalVariables";
import {
    adaptDateTimeForDateTimePicker,
    boolToString, formatDate,
    intToFloatCurrency,
    stringToBool,
    stringToInt
} from "../../component/Utils";
import CustomerSearchStep from "./CustomerSearchStep";
import {useRecoilState} from "recoil";
import {SELECTED_CUSTOMER_SALES} from "../../service/SalesMarketingRecoil";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
import {useHasScope} from "../../../../config/globalConfig";


const VoucherUpdatePage = () => {
    const {voucherId} = useParams();
    const {globalData} = useContext(GlobalContext);
    const {t} = useTranslation(['salesmarketing'], {keyPrefix: 'voucher'});
    const theme = useTheme();
    const hasScope = useHasScope;
    const navigate = useNavigate();
    const [voucher, setVoucher] = useState<RootVoucherGetSingleResponse['result']>();
    const [hasBeenAddedFirstTime,setHasBeenAddedFirstTime] = useState(false);
    const [disableUsedAndRefund,setDisableUsedAndRefund] = useState(false);
    const {dispatchGlobalData} = useContext(GlobalContext);
    const [isExpandedCustomer, setIsExpandedCustomer] = useState(true);
    const [isExpandedCustomerCb, setIsExpandedCustomerCb] = useState(true);
    const [isExpandedRenewal, setIsExpandedRenewal] = useState(true);
    const [openDetailCustomer, setOpenDetailCustomer] = useState(false);
    const [customerSelected, setCustomerSelected] = useRecoilState(SELECTED_CUSTOMER_SALES);
    const linkToInvoice = "/finance/invoices/";
    const SCOPE_INVOICE = "SCOPE_SM_FINANCE_RECEIVABLE_VIEW_DETAIL";

    const defautValues = {
        id:voucher?.id ?? '',
        dealerId:voucher?.dealerId ?? '',
        tenantId:voucher?.tenantId ?? '',
        status:voucher?.status ?? '',
        code: voucher?.code ?? '',
        subscription:voucher?.subName ?? '',
        sku:voucher?.sku ?? '',
        price:voucher?.price ? intToFloatCurrency(voucher.price.toString()) : "",
        reservationDate:voucher?.reservationDate ? adaptDateTimeForDateTimePicker(voucher.reservationDate) : null,
        bookingCode:voucher?.bookingCode ?? '',
        amazonBookingStatus:voucher?.amazonBookingStatus ?? '',
        amazonEmail:voucher?.amazonEmail ?? '',
        invoiceCode:voucher?.invoiceCode ?? '',
        invoiceError:voucher?.invoiceStatusNote ?? '',
        invoiceDate:voucher?.invoiceDate ? adaptDateTimeForDateTimePicker(voucher.invoiceDate) : null,
        provider:voucher?.provider ?? '',
        note:voucher?.note ?? '',
        creditNoteNumber:voucher?.creditNoteNumber ?? '',
        creditNoteDate:voucher?.creditNoteDate ? adaptDateTimeForDateTimePicker(voucher.creditNoteDate)  : null,
        creditNote:stringToBool(voucher?.creditNote ?? 'n') ?? false,
        refund:stringToBool(voucher?.refund ?? 'n')  ?? false,
        refundDate:voucher?.refundDate ? adaptDateTimeForDateTimePicker(voucher.refundDate) : null,
        refundNote:voucher?.refundNote ?? '',
        renewalsList: voucher?.renewalsList ?? [],
        createdDate: voucher?.createdDate ? voucher.createdDate : null,
        lastModifiedDate: voucher?.lastModifiedDate ? adaptDateTimeForDateTimePicker(voucher.lastModifiedDate) : null,
        isAmazonBusiness: voucher?.isAmazonBusiness ?  t(voucher.isAmazonBusiness === 1 ? 'customerAssociated.yes' : 'customerAssociated.no' )  : '',
        isCustomerAssociated: voucher?.isAmazonBusiness ? t(voucher.isAmazonBusiness === 1 && voucher.bpCode && voucher.bpCode !== "" ? 'customerAssociated.yes' : 'customerAssociated.no' )  : '',
        vatNumber: voucher?.amazonInvoiceData?.[0]?.vatNumber  ? voucher?.amazonInvoiceData[0].vatNumber : '',
        businessName: voucher?.amazonInvoiceData?.[0]?.businessName  ? voucher?.amazonInvoiceData[0].businessName : '',
        address: voucher?.amazonInvoiceData?.[0]?.address  ? voucher?.amazonInvoiceData[0].address : '',
        city: voucher?.amazonInvoiceData?.[0]?.city  ? voucher?.amazonInvoiceData[0].city : '',
        country: voucher?.amazonInvoiceData?.[0]?.country ? voucher?.amazonInvoiceData[0].country : '',
        zipCode: voucher?.amazonInvoiceData?.[0]?.zipCode  ? voucher?.amazonInvoiceData[0].zipCode : '',
        bpCode: voucher?.bpCode  ?? '',
        amazonInvoiceStatus: voucher?.amazonInvoiceStatus  ?? '',
        invoiceId: voucher?.invoiceId ?? ''
    }

    const validationSchema = Yup.object({
        status: Yup.string().required(t('createForm.requiredCheck')),
        renewalsList: Yup.array().of(Yup.object().shape({
            renewalDate: Yup.date().required(t('createForm.requiredCheck')),
            note: Yup.string().nullable()
        })),
        note:Yup.string().nullable(),
        creditNote:Yup.boolean().nullable(),
        creditNoteDate:Yup.date().nullable(),
        creditNoteNumber:Yup.string().nullable(),
        refund:Yup.boolean().nullable(),
        refundDate:Yup.date().nullable(),
        refundNote:Yup.string().nullable(),
        createdDate:Yup.string().nullable(),
        lastModifiedDate:Yup.string().nullable()
    });
    


    const {handleSubmit, control, setValue, watch, reset, formState, setError, clearErrors, getValues} = useForm({
        defaultValues:defautValues,
        resolver: yupResolver(validationSchema)
    });

    const {fields, append, remove, update} = useFieldArray({
        control,
        name: "renewalsList"
    });
    const { getVoucherById , updateVoucher } = useVoucherActions();
    const {statuses} = useVoucherStatuses();
    const [openCreationModal, setOpenCreationModal] = useState(false);
    const [openUpdateVoucherWithCustomerModal, setOpenUpdateVoucherWithCustomerModal] = useState(false);
    const [confirmCustomer, setConfirmCustomer] = useState(false);

    useEffect(() => {
        getVoucherById(voucherId!).then(res => {
            setVoucher(res);
            setDisableUsedAndRefund(res.status === VOUCHER_STATUS_REFUNDED || (res.status === VOUCHER_STATUS_USED && res.provider !== VOUCHER_PROVIDER_AMAZON))
        });
    }, []);

    useEffect(() => {
        reset(defautValues)
    }, [voucher])


    useEffect(() => {
       console.log("customerSelected ",customerSelected)
    }, [customerSelected])



    const onSubmit = (values: any) => {

        if(voucher?.provider && voucher.provider === VOUCHER_PROVIDER_AMAZON &&
            voucher.isAmazonBusiness === 1 && !confirmCustomer  && (voucher.bpCode === undefined || voucher.bpCode === "")) {
            setOpenUpdateVoucherWithCustomerModal(true);
        } else {
           submitFunction(values);
        }
    }

    const submitFunction = async (values: any) => {
        if (globalData?.user?.legalEntities?.length === 1) {
            values = {...values, tenantId: globalData?.user?.legalEntities[0].name};
        }
        if (globalData?.user?.dealers?.length === 1) {
            values = {...values, dealerId: globalData?.user?.dealers[0].name}
        }

        if(watch('creditNote') || watch('refund')){
            values = {...values, status:VOUCHER_STATUS_REFUNDED}
        }
        let payload = {...values,
            creditNote: values.creditNote ? boolToString(values.creditNote) : null,
            creditNoteNumber: values?.creditNoteNumber && values.creditNoteNumber !== "" ? values.creditNoteNumber : null,
            refund: values.refund ? boolToString(values.refund) : null,
            isAmazonBusiness:values.isAmazonBusiness ? stringToInt(values.isAmazonBusiness) : "",
            isCustomerAssociated: values.isCustomerAssociated !== "" ? stringToInt(values.isCustomerAssociated) : "",
            bpCode: customerSelected?.[0]?.bpCode ? customerSelected[0].bpCode : values.bpCode,
            lastModifiedDate:  voucher?.lastModifiedDate ? voucher.lastModifiedDate : null
        };
        let data = await updateVoucher(payload);
        if (data && data.status === 'OK') {
            setOpenCreationModal(true);
        } else {
            dispatchGlobalData({
                type: setSnackbar,
                payload: {
                    snackbar: {
                        message: t("downloadError"),
                        type: snackbarTypes.error,
                        show: true,
                        autoClose: true,
                    }
                }
            });
        }
    }

    const belowVoucherWithInvoiceContent = <Grid container rowSpacing={3} columnSpacing={3} sx={{paddingTop:"50px"}}>
    <Grid item xs={3}>
        <Controller
            control={control}
            name={"creditNote"}
            render={({field}: any) => (
                <FormControlLabel
                    sx={{
                        marginTop:"20px"
                    }} 
                    disabled={watch('status') === VOUCHER_STATUS_EXPIRED || disableUsedAndRefund}
                    control={<Checkbox checked={field.value} />} 
                    label={t('inputUpdatePageFields.creditNote')} 
                    value={field.value} 
                    onChange={(e)=>{
                        field.onChange(e)
                        setValue('creditNote',!field.value)
                        if(!watch('creditNote')){
                            setValue('creditNoteNumber','')
                            setValue('creditNoteDate',null)
                        } 
                    }} 
               />
            )}/>
    </Grid>    
    <Grid item xs={3}>
        <Controller
            control={control}
            name={"creditNoteNumber"}
            render={({field}: any) => (
                <TextField
                    fullWidth
                    label={t('inputUpdatePageFields.creditNoteNumber')}
                    disabled={disableUsedAndRefund || (watch('status') === VOUCHER_STATUS_EXPIRED || (watch('status') === VOUCHER_STATUS_AVAILABLE && !watch('creditNote')))}
                    value={field.value}
                    onChange={field.onChange}
                    InputProps={{
                        endAdornment: (
                            hasScope(SCOPE_INVOICE) && (
                                <Tooltip arrow title={t('inputUpdatePageFields.invoiceLink')}>
                                    <Button
                                        sx={{ color: theme.palette.accent.main, textTransform: "none", minWidth: "unset", whiteSpace: "nowrap" }}
                                        disabled={!watch('creditNoteNumber')}
                                        onClick={() => {
                                            window.open(linkToInvoice + watch('invoiceId')+'/linked-documents', "_blank");
                                        }}
                                        variant="text"
                                    >
                                        {t('inputUpdatePageFields.invoiceLink')}
                                    </Button>
                                </Tooltip>
                            )
                        )
                    }}
                />
            )}
        />
    </Grid>    
    <Grid item xs={3}>
        <Controller
            control={control}
            name={"creditNoteDate"}
            render={({field,fieldState}: any) => (
                <DateTimePicker
                    label={t('inputUpdatePageFields.creditNoteDate')}
                    value={field.value}
                    onChange={field.onChange}
                    ampm={false}
                    disabled={disableUsedAndRefund || (watch('status') === VOUCHER_STATUS_EXPIRED || (watch('status') === VOUCHER_STATUS_AVAILABLE && !watch('creditNote')))}
                    renderInput={(params) =>
                        <TextField
                            {...params}
                            required
                            fullWidth
                            error={!!fieldState.error}
                            helperText={fieldState.error?.message}
                            disabled={disableUsedAndRefund || (watch('status') === VOUCHER_STATUS_EXPIRED || (watch('status') === VOUCHER_STATUS_AVAILABLE && !watch('creditNote')))}
                        />}
                    inputFormat={"DD/MM/YYYY HH:mm"}
                />
            )}/>
    </Grid>
    <Grid item xs={3}></Grid>   
    </Grid>
    const belowVoucherWithoutInvoiceContent = <Grid container rowSpacing={3} columnSpacing={3} sx={{paddingTop:"50px"}}>
    <Grid item xs={3}>
        <Controller
            control={control}
            name={"refund"}
            render={({field}: any) => (
                <FormControlLabel
                    sx={{
                        marginTop:"20px"
                    }} 
                    disabled={watch('status') === VOUCHER_STATUS_EXPIRED || disableUsedAndRefund}
                    control={<Checkbox checked={field.value} />} 
                    label={t('inputUpdatePageFields.refund')} 
                    value={field.value} 
                    onChange={(e)=>{
                        field.onChange(e)
                        setValue('refund',!field.value)
                        if(!watch('refund')){
                            setValue('refundDate',null)
                        } 
                    }} 
                />
            )}/>
    </Grid>    
    <Grid item xs={3}>
        <Controller
            control={control}
            name={"refundDate"}
            render={({field,fieldState}: any) => (
                <DateTimePicker
                    label={t('inputUpdatePageFields.refundDate')}
                    ampm={false}
                    value={field.value}
                    onChange={field.onChange}
                    disabled={disableUsedAndRefund || (watch('status') === VOUCHER_STATUS_EXPIRED || (watch('status') === VOUCHER_STATUS_AVAILABLE && !watch('refund')))}
                    renderInput={(params) =>
                        <TextField
                            {...params}
                            required
                            fullWidth
                            error={!!fieldState.error}
                            helperText={fieldState.error?.message}
                            disabled={disableUsedAndRefund || (watch('status') === VOUCHER_STATUS_EXPIRED || (watch('status') === VOUCHER_STATUS_AVAILABLE && !watch('refund')))}
                        />}
                inputFormat={"L HH:mm"}
            />
            )}/>
    </Grid>    
    <Grid item xs={3}></Grid>   
    <Grid item xs={3}></Grid>   
    </Grid>
    const getDynamicStatuses = () => {
       let newStatuses = [...statuses]
        if(voucher?.status === VOUCHER_STATUS_EXPIRED || voucher?.status === VOUCHER_STATUS_AVAILABLE){
            newStatuses = statuses.filter(el => el.value === VOUCHER_STATUS_EXPIRED || el.value === VOUCHER_STATUS_AVAILABLE)
        }
         return newStatuses?.map((newStatus) => ( <MenuItem key={newStatus.value} value={newStatus.value}> {newStatus.label} </MenuItem> ))
    }


    return (
        <>
            <SectionHeader
                title={t('inputUpdatePageFields.title')}
                subtitle={t('inputUpdatePageFields.subtitle')}/>
            <Paper elevation={3} sx={{padding: "16px", margin: "18px"}}>
                <form key={"updateVoucher"} onSubmit={handleSubmit(data => {
                    onSubmit({...data}); }, errors => console.log(errors))} noValidate>
                    <Grid container rowSpacing={3} columnSpacing={3}>

                        <UserLegalEntitiesOrDealersInputGroup
                            control={control}
                            disabled={!!voucherId}
                            hasCreatedDateFieldInsideVoucherUpdate
                            createdDateValue={voucher?.createdDate ? formatDate(dayjs(voucher.createdDate).toDate()) : ""}
                            itemWrappercolumns={6}
                            itemColumns={6}
                        />

                        <Grid item xs={4}>
                            <TextField
                                fullWidth
                                label={t('inputUpdatePageFields.lastModifiedDate')}
                                value={voucher?.lastModifiedDate ?  formatDate(voucher.lastModifiedDate) : '--' }
                                margin="dense"
                                variant="standard"
                                disabled={true}
                                inputProps={
                                    {readOnly: true}
                                }
                            />
                        </Grid>
                        <Grid item xs={3}>
                        <Controller
                            control={control}
                            name={"status"}
                            render={({field}) => (
                                <TextField
                                    fullWidth
                                    name="status"
                                    label={t('inputUpdatePageFields.status')}
                                    select={true}
                                    disabled={voucher?.status !== VOUCHER_STATUS_EXPIRED && voucher?.status !== VOUCHER_STATUS_AVAILABLE}
                                    value={field.value}
                                    onChange={(e)=>{
                                        field.onChange(e);
                                        if(e.target.value === VOUCHER_STATUS_AVAILABLE && !hasBeenAddedFirstTime && voucher?.status === VOUCHER_STATUS_EXPIRED){
                                            append({
                                                renewalDate:dayjs().utcOffset(0).startOf("date").toDate(),
                                                renewalNote:''
                                            });
                                            setHasBeenAddedFirstTime(true);
                                        } else if(e.target.value === VOUCHER_STATUS_EXPIRED && voucher?.status === VOUCHER_STATUS_EXPIRED ) {
                                            remove(fields.length - 1);
                                            setHasBeenAddedFirstTime(false);
                                        }
                                    }}
                                >
                                    {getDynamicStatuses()}
                                </TextField>
                            )}/>

                        </Grid>
                        <Grid item xs={3}>
                        <Controller
                            control={control}
                            name={"code"}
                            render={({field}: any) => (
                                <TextField
                                fullWidth
                                name="code"
                                label={t('inputUpdatePageFields.voucherCode')}
                                value={voucher?.code ?? ''}
                                disabled
                            />
                            )}/>

                        </Grid>
                        <Grid item xs={3}>
                        <Controller
                            control={control}
                            name={"subscription"}
                            render={({field}: any) => (
                                <TextField
                                fullWidth
                                name="subscription"
                                label={t('inputUpdatePageFields.subscription')}
                                value={voucher?.subName ?? ''}
                                disabled
                            />
                            )}/>

                        </Grid>
                        <Grid item xs={3}>
                        <Controller
                            control={control}
                            name={"sku"}
                            render={({field}: any) => (
                                <TextField
                                fullWidth
                                name="sku"
                                label={t('inputUpdatePageFields.sku')}
                                value={field.value}
                                disabled
                            />
                            )}/>

                        </Grid>
                        <Grid item xs={3}>
                        <Controller
                            control={control}
                            name={"price"}
                            render={({field}: any) => (
                                <TextField
                                fullWidth
                                name="price"
                                label={t('inputUpdatePageFields.price')}
                                value={field.value}
                                disabled
                            />
                            )}/>

                        </Grid>
                        <Grid item xs={3}>
                            <Controller
                            control={control}
                            name={"reservationDate"}
                            render={({field,fieldState}: any) => (
                                <DatePicker
                                    label={t('inputUpdatePageFields.reservationDate')}
                                    value={field.value}
                                    onChange={field.onChange}
                                    disabled
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            required
                                            fullWidth
                                            error={!!fieldState.error}
                                            helperText={fieldState.error?.message}
                                            disabled
                                        />}
                                    inputFormat={"L HH:mm"}
                                />
                            )}/>
                        </Grid>
                        <Grid item xs={3}>
                            <Controller
                                control={control}
                                name={"bookingCode"}
                                render={({field}: any) => (
                                    <TextField
                                        fullWidth
                                        name="bookingCode"
                                        label={t('inputUpdatePageFields.bookingCode')}
                                        value={field.value}
                                        disabled
                                    />
                                )}/>
                        </Grid>
                        <Grid item xs={3}>
                        <Controller
                            control={control}
                            name={"amazonBookingStatus"}
                            render={({field}: any) => (
                                <TextField
                                    fullWidth
                                    name="amazonBookingStatus"
                                    label={t('inputUpdatePageFields.amazonBookingStatus')}
                                    value={field.value}
                                    disabled
                                />
                            )}/>
                        </Grid>
                        <Grid item xs={3}>
                        <Controller
                            control={control}
                            name={"invoiceCode"}
                            render={({field}: any) => (
                                <TextField
                                fullWidth
                                name="invoiceCode"
                                label={t('inputUpdatePageFields.invoice')}
                                value={field.value}
                                disabled
                                InputProps={{
                                    endAdornment: (
                                        hasScope(SCOPE_INVOICE) && watch('invoiceDate') && watch('invoiceDate') !== null && (
                                            <Tooltip arrow title={t('inputUpdatePageFields.invoiceLink')}>
                                                <Button
                                                    sx={{ color: theme.palette.accent.main, textTransform: "none", minWidth: "unset", whiteSpace: "nowrap" }}
                                                    onClick={() => {
                                                        window.open(linkToInvoice + watch('invoiceId'), "_blank");
                                                    }}
                                                    variant="text"
                                                >
                                                    {t('inputUpdatePageFields.invoiceLink')}
                                                </Button>
                                            </Tooltip>
                                        )
                                    )
                                }}
                            />
                            )}/>
                        </Grid>
                        <Grid item xs={3}>
                            <Controller
                                control={control}
                                name={"invoiceDate"}
                                render={({ field }: any) => (
                                    <DatePicker
                                        label={t("inputUpdatePageFields.invoiceDate")}
                                        value={field.value}
                                        renderInput={(params) =>
                                            <TextField
                                                {...params}
                                                disabled
                                            />
                                        }
                                        inputFormat={"L HH:mm"}
                                        disabled
                                        onChange={field.onChange}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={3}>
                            <Controller
                                control={control}
                                name={"provider"}
                                render={({field}: any) => (
                                    <TextField
                                        fullWidth
                                        name="invoiceDate"
                                        label={t('inputUpdatePageFields.provider')}
                                        value={field.value}
                                        disabled
                                    />
                                )}/>
                        </Grid>
                        <Grid item xs={3}>
                            <Controller
                                control={control}
                                name={"amazonEmail"}
                                render={({field}: any) => (
                                    <TextField
                                        fullWidth
                                        name="amazonEmail"
                                        label={t('inputUpdatePageFields.amazonMail')}
                                        value={field.value}
                                        disabled
                                    />
                                )}/>
                        </Grid>
                        { voucher?.provider && voucher.provider === VOUCHER_PROVIDER_AMAZON  &&
                            <>
                                <Grid item xs={3}>
                                    <Controller
                                        control={control}
                                        name={"isAmazonBusiness"}
                                        render={({field}: any) => (
                                            <TextField
                                                fullWidth
                                                name="isAmazonBusiness"
                                                label={t('inputUpdatePageFields.isAmazonBusiness')}
                                                value={field.value}
                                                disabled
                                            />
                                        )}/>
                                </Grid>
                                <Grid item xs={3}>
                                    <Controller
                                        control={control}
                                        name={"bpCode"}
                                        render={({field}: any) => (
                                            <TextField
                                                fullWidth
                                                name="bpCode"
                                                label={t('inputUpdatePageFields.bpCode')}
                                                value={field.value}
                                                disabled
                                            />
                                        )}/>
                                </Grid>
                                <Grid item xs={3}>
                                    <Controller
                                        control={control}
                                        name={"amazonInvoiceStatus"}
                                        render={({field}: any) => (
                                            <TextField
                                                fullWidth
                                                name="amazonInvoiceStatus"
                                                label={t('inputUpdatePageFields.amazonInvoiceStatusLabel')}
                                                value={field.value ? t('inputUpdatePageFields.amazonInvoiceStatus.'+field.value) : ""}
                                                disabled
                                            />
                                        )}/>
                                </Grid>
                            </>
                        }
                        { ( voucher?.provider &&
                                voucher.provider === VOUCHER_PROVIDER_AMAZON &&
                                voucher.isAmazonBusiness === 1 &&
                                (voucher.bpCode === undefined || voucher.bpCode === "") &&
                                (voucher.amazonInvoiceStatus === "CUSTOMERBASE_KO" || voucher.amazonInvoiceStatus === "TOBE_SENT")
                            )
                            &&
                            (customerSelected[0]?.bpCode !== undefined ?
                                    <>
                                        <Stack direction="row" alignItems="end" columnGap={1}>
                                            <Grid item xs={1} sm={2} alignItems="center"
                                                  sx={{textAlign: 'right', marginTop: 'auto'}}>
                                                <Tooltip arrow placement={"bottom"}
                                                         title={t('inputUpdatePageFields.updateForm.infoConfirmCustomer')}>
                                                    <InfoRounded color="primary"/>
                                                </Tooltip>
                                            </Grid>
                                            <Grid item xs={1}>
                                                <Button size={"medium"} fullWidth variant="text" component="label"
                                                        onClick={() => setCustomerSelected("")}>
                                                    {t('inputUpdatePageFields.disassociateClient')}
                                                </Button>
                                            </Grid>
                                        </Stack>
                                    </>
                                    :
                                    <Grid item xs={1}>
                                        <Button size={"medium"} fullWidth variant="text" component="label"
                                                onClick={() => setOpenDetailCustomer(true)}>
                                            {t('inputUpdatePageFields.associateClient')}
                                        </Button>
                                    </Grid>
                            )
                        }
                    </Grid>
                    {voucher?.invoiceCode ? belowVoucherWithInvoiceContent : belowVoucherWithoutInvoiceContent}
                    <Grid item xs={12}>
                        <Controller
                            control={control}
                            name={"note"}
                            render={({field}: any) => (
                                <TextField
                                fullWidth
                                name="note"
                                label={t('inputUpdatePageFields.note')}
                                value={field.value}
                                onChange={field.onChange}
                            />
                            )}/>
                    </Grid>
                    {voucher?.isAmazonBusiness === 1 &&
                        <>
                            <Grid item xs={12}  sx={{ marginTop:"50px"}}>
                                <Accordion defaultExpanded onChange={(_e, expanded) => {
                                    setIsExpandedCustomer(expanded);
                                }}>
                                    <AccordionSummary expandIcon={<ExpandMore/>}>
                                        {t('inputUpdatePageFields.customerDetails')}
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Grid rowSpacing={3} columnSpacing={3}>
                                            <Grid container item xs={12} rowSpacing={1} columnSpacing={3}>
                                                <Grid item xs={3}>
                                                    <Controller
                                                        control={control}
                                                        name={"vatNumber"}
                                                        render={({field}: any) => (
                                                            <TextField
                                                                fullWidth
                                                                name="vatNumber"
                                                                label={t('inputUpdatePageFields.vatNumber')}
                                                                value={field.value}
                                                                disabled
                                                            />
                                                        )}/>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <Controller
                                                        control={control}
                                                        name={"businessName"}
                                                        render={({field}: any) => (
                                                            <TextField
                                                                fullWidth
                                                                name="businessName"
                                                                label={t('inputUpdatePageFields.businessName')}
                                                                value={field.value}
                                                                disabled
                                                            />
                                                        )}/>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <Controller
                                                        control={control}
                                                        name={"address"}
                                                        render={({field}: any) => (
                                                            <TextField
                                                                fullWidth
                                                                name="address"
                                                                label={t('inputUpdatePageFields.address')}
                                                                value={field.value}
                                                                disabled
                                                            />
                                                        )}/>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <Controller
                                                        control={control}
                                                        name={"city"}
                                                        render={({field}: any) => (
                                                            <TextField
                                                                fullWidth
                                                                name="city"
                                                                label={t('inputUpdatePageFields.city')}
                                                                value={field.value}
                                                                disabled
                                                            />
                                                        )}/>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <Controller
                                                        control={control}
                                                        name={"country"}
                                                        render={({field}: any) => (
                                                            <TextField
                                                                fullWidth
                                                                name="country"
                                                                label={t('inputUpdatePageFields.country')}
                                                                value={field.value}
                                                                disabled
                                                            />
                                                        )}/>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <Controller
                                                        control={control}
                                                        name={"zipCode"}
                                                        render={({field}: any) => (
                                                            <TextField
                                                                fullWidth
                                                                name="zipCode"
                                                                label={t('inputUpdatePageFields.zipCode')}
                                                                value={field.value}
                                                                disabled
                                                            />
                                                        )}/>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </AccordionDetails>
                                </Accordion>
                            </Grid>
                            {customerSelected[0]?.bpCode !== undefined &&
                                <Grid item xs={12}  sx={{ marginTop:"50px"}}>
                                    <Accordion defaultExpanded onChange={(_e, expanded) => {
                                        setIsExpandedCustomerCb(expanded);
                                    }}>
                                    <AccordionSummary expandIcon={<ExpandMore/>}>
                                        {t('inputUpdatePageFields.customerDetailsFromCB')}
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Grid rowSpacing={3} columnSpacing={3}>
                                            <Grid container item xs={12} rowSpacing={1} columnSpacing={3}>
                                                <Grid item xs={3}>
                                                    <TextField
                                                        fullWidth
                                                        name="bpCode"
                                                        label={t('inputUpdatePageFields.bpCode')}
                                                        value={customerSelected[0]?.bpCode ? customerSelected[0].bpCode : ""}
                                                        disabled
                                                    />
                                                </Grid>
                                                {customerSelected[0]?.taxCode &&
                                                    <Grid item xs={3}>
                                                        <TextField
                                                            fullWidth
                                                            name="taxCode"
                                                            label={t('inputUpdatePageFields.taxCode')}
                                                            value={customerSelected[0].taxCode}
                                                            disabled
                                                        />
                                                    </Grid>
                                                }
                                                {customerSelected[0]?.vatNumber &&
                                                    <Grid item xs={3}>
                                                        <TextField
                                                            fullWidth
                                                            name="vatNumber"
                                                            label={t('inputUpdatePageFields.vatNumber')}
                                                            value={customerSelected[0].vatNumber}
                                                            disabled
                                                        />
                                                    </Grid>
                                                }
                                                {customerSelected[0]?.companyName ?
                                                    <Grid item xs={3}>
                                                        <TextField
                                                            fullWidth
                                                            name="companyName"
                                                            label={t('inputUpdatePageFields.businessName')}
                                                            value={customerSelected[0].companyName}
                                                            disabled
                                                        />
                                                    </Grid>
                                                    :
                                                    <>
                                                        <Grid item xs={3}>
                                                            <TextField
                                                                fullWidth
                                                                name="firstName"
                                                                label={t('inputUpdatePageFields.firstName')}
                                                                value={customerSelected[0].firstName}
                                                                disabled
                                                            />
                                                        </Grid>
                                                        <Grid item xs={3}>
                                                            <TextField
                                                                fullWidth
                                                                name="companyName"
                                                                label={t('inputUpdatePageFields.lastName')}
                                                                value={customerSelected[0].lastName}
                                                                disabled
                                                            />
                                                        </Grid>
                                                    </>

                                                }
                                                <Grid item xs={3}>
                                                    <TextField
                                                        fullWidth
                                                        name="address"
                                                        label={t('inputUpdatePageFields.address')}
                                                        value={customerSelected[0]?.address?.street ? customerSelected[0].address.street : ""}
                                                        disabled
                                                    />
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <TextField
                                                        fullWidth
                                                        name="city"
                                                        label={t('inputUpdatePageFields.city')}
                                                        value={customerSelected[0]?.address?.city ? customerSelected[0].address.city : ""}
                                                        disabled
                                                    />
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <TextField
                                                        fullWidth
                                                        name="country"
                                                        label={t('inputUpdatePageFields.country')}
                                                        value={customerSelected[0]?.address?.country ? customerSelected[0].address.country : ""}
                                                        disabled
                                                    />
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <TextField
                                                        fullWidth
                                                        name="zipCode"
                                                        label={t('inputUpdatePageFields.zipCode')}
                                                        value={customerSelected[0]?.address?.zipCode ? customerSelected[0].address.zipCode : ""}
                                                        disabled
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </AccordionDetails>
                                </Accordion>
                            </Grid>
                            }
                        </>
                    }
                    <Grid item xs={12} sx={{paddingTop: '50px'}}>
                        <Accordion defaultExpanded onChange={(_e, expanded) => {
                            setIsExpandedRenewal(expanded);
                        }}>
                            <AccordionSummary expandIcon={<ExpandMore/>}>
                                {t('inputUpdatePageFields.renewalsSection.title')}
                            </AccordionSummary>
                            <AccordionDetails>
                                <Grid container rowSpacing={3} columnSpacing={3} sx={{paddingTop: '50px'}}>
                                    <Grid item container xs={12}>
                                        {fields.length === 0 ? <EmptyState icon={<DoDisturbAltRounded/>}
                                                                           title={t('inputUpdatePageFields.renewalsSection.noValuesTitle')}
                                                                           content={t('inputUpdatePageFields.renewalsSection.noValuesContent')}/>
                                            :
                                            <Renewaltems formState={formState} fields={fields} control={control}/>}
                                    </Grid>
                                </Grid>

                            </AccordionDetails>
                        </Accordion>
                    </Grid>
                    <Grid container rowSpacing={3} columnSpacing={3} sx={{paddingTop: "50px"}}>
                        <Grid container item xs={12} rowSpacing={1} columnSpacing={3} justifyContent={"flex-end"}>
                            <Grid item>
                                <Button variant={"outlined"} color={"accent"}
                                        onClick={() => {
                                            navigate("/salesmarketing/voucherlist")
                                        }}>
                                    {t('inputUpdatePageFields.cancel')}
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button color={"accent"}
                                        type="submit">{t('inputUpdatePageFields.confirm')}</Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </form>
            </Paper>
            <CustomModal title={t('inputUpdatePageFields.updateForm.modalTitleSuccess')}
                         content={()=> <p>{t('inputUpdatePageFields.updateForm.modalDescriptionSuccess')}</p>}
                         cancelButton={t('inputUpdatePageFields.updateForm.close')}
                         open={openCreationModal}
                         titleIcon={<CheckCircleRounded color={"success"}/>}
                         onClose={() => {
                             setOpenCreationModal(false);
                             navigate("/salesmarketing/voucherlist")
                         }}/>
            <CustomModal title={t('inputUpdatePageFields.updateForm.modalDescriptionUpdateVoucher')}
                         content={()=>
                             <>
                                { customerSelected[0]?.bpCode !== undefined ?
                                    <>
                                        <p>
                                            {t('inputUpdatePageFields.updateForm.modalTitleUpdateVoucher',
                                                {voucherCode: voucher?.code ? voucher.code : "" })}
                                        </p>
                                        <p>
                                            {t('inputUpdatePageFields.updateForm.modalTitleUpdateVoucherCustomerBPCode',
                                                    {bpCode: customerSelected[0]?.bpCode  }) }
                                        </p>
                                        <p>
                                            {t('inputUpdatePageFields.updateForm.modalTitleUpdateVoucherCustomerNominative',
                                                    {clientName: customerSelected[0]?.companyName ? customerSelected[0].companyName : customerSelected[0]?.lastName + " " + customerSelected[0]?.firstName})
                                            }
                                        </p>
                                        <p>
                                            {t('inputUpdatePageFields.updateForm.modalTitleUpdateVoucherCustomerCFPiva',
                                                    { vatOrTax: customerSelected[0]?.vatNumber ? customerSelected[0].vatNumber : customerSelected[0]?.taxCode})
                                            }
                                        </p>
                                        <p><b>{t('inputUpdatePageFields.updateForm.modalTitleUpdateVoucherAttention')}</b></p>
                                        <p>{t('inputUpdatePageFields.updateForm.modalTitleUpdateVoucherConfirm')}</p>
                                    </>
                                 :
                                    <p>
                                        {t('inputUpdatePageFields.updateForm.modalTitleUpdateVoucherNoCustomer')}
                                    </p>
                                }
                            </>
                         }
                         open={openUpdateVoucherWithCustomerModal}
                         titleIcon={<InfoRoundedIcon color={"warning"} />}
                         confirmButton={t('inputUpdatePageFields.updateForm.confirm')}
                         cancelButton={t('inputUpdatePageFields.updateForm.cancel')}
                         callback={() => {
                             setConfirmCustomer(true);
                             setOpenUpdateVoucherWithCustomerModal(false);
                             submitFunction(getValues());
                         }}
                         onClose={() => {
                             setOpenUpdateVoucherWithCustomerModal(false);
                         }}
            />

            <CustomerSearchStep open={openDetailCustomer}
                                    handleClose={() => setOpenDetailCustomer(false)}
            />

        </>
    );
}

export default VoucherUpdatePage;